export default {
  computed: {
    analyticsTotal: function () {
      if (this.order) {
        if (this.order.total) {
          return this.order.total.toString()
        }
      }
      return null
    },
    analyticsName: function () {
      if (this.data) {
        if (this.data.account) {
          return this.data.account.name
        }
      }
      return null
    },
    analyticsId: function () {
      if (this.data) {
        if (this.data.account) {
          return this.data.account.id
        }
      }
      return null
    },
    analyticsCurrency: function () {
      if (this.data) {
        if (this.data.account) {
          return this.data.account.currency
        }
      }
      return 'USD'
    }
  },
  methods: {
    analyticsStartCheckout () {
      var e = {
        'send_to': 'main',
        'AccountId': this.analyticsId,
        'AccountName': this.analyticsName,
        'value': this.analyticsTotal,
        'currency': this.analyticsCurrency,
        'checkout_step': 1,
        'transaction_id': this.confirmationNumber
      }
      window.gtag('event', 'begin_checkout', e)
    },
    analyticsStartPayment (method) {
      var e = {
        'send_to': 'main',
        'AccountId': this.analyticsId,
        'AccountName': this.analyticsName,
        'value': this.analyticsTotal,
        'currency': this.analyticsCurrency,
        'checkout_step': 2,
        'checkout_option': method
      }
      window.gtag('event', 'checkout_progress', e)
    },
    analyticsCompletePurchase () {
      var e = {
        'send_to': 'main',
        'AccountId': this.analyticsId,
        'AccountName': this.analyticsName,
        'value': this.analyticsTotal,
        'currency': this.analyticsCurrency,
        'checkout_step': 3,
        'transaction_id': this.confirmationNumber
      }
      window.gtag('event', 'purchase', e)
    },
    analyticsButtonClick (label) {
      var e = {
        'send_to': 'main',
        'AccountId': this.analyticsId,
        'AccountName': this.analyticsName,
        'event_category': 'engagement',
        'event_label': label
      }
      window.gtag('event', 'clicked', e)
    },
    analyticsFormSubmit (label) {
      var e = {
        'send_to': 'main',
        'AccountId': this.analyticsId,
        'AccountName': this.analyticsName,
        'event_category': 'engagement',
        'event_label': label
      }
      window.gtag('event', 'form_submit', e)
    }
  }
}
